export default "__VITE_ASSET__C9D6exyn__"